// extracted by mini-css-extract-plugin
module.exports = {"header":"playerBlockHeader_header_1d_u7IO","divider":"playerBlockHeader_divider_3cW-h6V","liveSwitchButton":"playerBlockHeader_liveSwitchButton_n2V1G8A"};